import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/Evidenza/Card_inizioCorsi.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";


function InizioCorsi () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{""}</p>
            <div className="container-foto-news m-auto d-none d-sm-block " style={{display: "flex", flexDirection: "column", width: "50%"}}>
                <img src={locandina} style={{width: "100%"}}></img>
            </div>
            <div className="container-foto-news m-auto d-sm-none" style={{display: "flex", flexDirection: "column", width: "80%"}}>
                <img src={locandina} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default InizioCorsi